var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56169 13H4.08534C3.35541 13 2.99043 13 2.71164 12.8547C2.46639 12.7269 2.26701 12.5229 2.14206 12.272C2 11.9868 2 11.6134 2 10.8667V4.46667C2 3.71993 2 3.34656 2.14206 3.06135C2.26701 2.81046 2.46639 2.60649 2.71164 2.47866C2.99043 2.33333 3.35541 2.33333 4.08534 2.33333H11.6447C12.3747 2.33333 12.7397 2.33333 13.0184 2.47866C13.2637 2.60649 13.4631 2.81046 13.588 3.06135C13.7301 3.34656 13.7301 3.71993 13.7301 4.46667V5.66667M4.60668 1V2.33333M11.1234 1V2.33333M2 5H13.7301M8.84254 7.66673L4.60668 7.66667M6.56169 10.3334L4.60668 10.3333M9.16837 13L10.488 12.73C10.603 12.7065 10.6606 12.6947 10.7142 12.6731C10.7618 12.6541 10.8071 12.6293 10.849 12.5993C10.8963 12.5656 10.9378 12.5232 11.0208 12.4383L13.7301 9.66667C14.09 9.29847 14.09 8.70153 13.7301 8.33333C13.3701 7.96513 12.7866 7.96513 12.4267 8.33333L9.71747 11.1049C9.63445 11.1899 9.593 11.2323 9.56002 11.2807C9.53076 11.3235 9.50652 11.3699 9.48789 11.4186C9.46684 11.4735 9.4553 11.5323 9.4323 11.65L9.16837 13Z",
    stroke: "#33363F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/Schedule.903f3fd43cdf49b54810b57c92329bf5.svg";
export { ForwardRef as ReactComponent };